import "./ReleaseGold.css";
import { Link } from "react-router-dom";

import heroImg from "../assets/neck2.webp";
import img1 from "../assets/goldimages.webp";
import img2 from "../assets/9007.webp";

export default function ReleaseGold() {
  return (
    <div className="release-page">

      {/* HERO */}
      <div
        className="hero-section"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="overlay"></div>

        {/* ✅ CENTER CONTENT */}
        <div className="hero-text">
          <h1>RELEASE PLEDGED GOLD</h1>
          <p>Get your gold back easily & quickly</p>

          {/* ✅ BREADCRUMB CENTER */}
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span> › </span>
            <span>Release Gold</span>
          </div>
        </div>
      </div>

      {/* TOP TEXT */}
      <div className="top-content">
        <h2>
          Release Pledged Gold in Bangalore with Cash for Gold! Need your gold back? We're here to help.
        </h2>
        <p>
          Do you have gold jewelry or valuables stuck in a pledge with a bank or pawnshop in Bangalore? Cash for Gold can help! We offer a convenient and secure solution to help you release your pledged gold easily.
        </p>
      </div>

      {/* CARDS */}
      <div className="release-wrapper">
        <div className="release-cards">

          {/* CARD 1 */}
          <div className="release-card">
            <img src={img1} alt="process" />

            <h3>How It Works:</h3>

            <ul>
              <li>
                <strong>Get a Free Quote:</strong> Bring your pledge receipt and ID. We check details and give a free quote.
              </li>
              <li>
                <strong>We Pay Off Loan:</strong> We directly clear your loan with bank/pawnbroker.
              </li>
              <li>
                <strong>Receive Your Gold:</strong> Once cleared, you get your gold back safely.
              </li>
            </ul>
          </div>

          {/* CARD 2 */}
          <div className="release-card">
            <img src={img2} alt="benefits" />

            <h3>Benefits:</h3>

            <ul>
              <li><strong>Fast & Hassle-Free:</strong> Quick process</li>
              <li><strong>Best Rates:</strong> Fair pricing</li>
              <li><strong>Safe & Secure:</strong> Trusted handling</li>
              <li><strong>Expert Team:</strong> Full guidance</li>
            </ul>
          </div>

        </div>
      </div>

      {/* BOTTOM TEXT */}
      <div className="bottom-text">
        <p>
          Don’t wait to reclaim your gold! Visit us today and get your valuables back quickly and safely.
        </p>
      </div>

    </div>
  );
}